/** Query value that enables Coral staging preview (development only). */
export const COMMENTS_PREVIEW_QUERY_VALUE = "test";

/**
 * Staging Coral story with a healthy comment thread (61 comments as of 2026-03).
 * From `window.coralStoryId` on staging.theverge.com.
 */
export const CORAL_PREVIEW_STORY_ID = "97380ff1-9e70-46bd-94ad-b58413d452fd";

/**
 * Permalink of that staging article (`window.location.href` without hash).
 * Used as a reference; in local dev the embed rewrites the host to localhost.
 */
export const CORAL_PREVIEW_STORY_URL: string | undefined =
  "https://staging.theverge.com/2024/5/28/24166143/apple-study-tinnitus-research-app-preliminary-data";

/** Known comment count on the staging preview thread (dev fallback when counts API is null). */
export const CORAL_PREVIEW_COMMENT_COUNT = 61;

function readCommentsPreviewFromSearch(search: string): boolean {
  const value = new URLSearchParams(search).get("comments");
  return value === COMMENTS_PREVIEW_QUERY_VALUE;
}

/** Client-only: detect preview mode from the URL before `router.isReady`. */
export function isCommentsPreviewLocation(): boolean {
  if (typeof window === "undefined" || process.env.NODE_ENV !== "development") {
    return false;
  }
  return readCommentsPreviewFromSearch(window.location.search);
}

export function isCommentsPreviewQuery(
  query: Record<string, string | string[] | undefined>,
): boolean {
  if (process.env.NODE_ENV !== "development") {
    return false;
  }

  const value = query.comments;
  if (value === COMMENTS_PREVIEW_QUERY_VALUE) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.includes(COMMENTS_PREVIEW_QUERY_VALUE);
  }
  return false;
}
